// KruskalInteractivePage.jsx
import React from 'react';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import KruskalsAlgo from './KruskalsAlgo';

export default function KruskalInteractivePage() {
  return (
    <section style={{ padding: '20px' }}>
      <Typography variant="h4" gutterBottom>
        Kruskal&apos;s MST Interactive
      </Typography>

      <Typography variant="body1" paragraph>
        Step through Kruskal&apos;s algorithm: examine edges in sorted order,
        decide whether to add or skip them, and watch the evolving Union-Find
        forest as the MST is constructed. This visulization is from Gemini3.
      </Typography>

      <Grid container justifyContent="center">
        <Grid item xs={12} md={12}>
          {/* Tailwind visualizer mounts as a full component */}
          <div style={{ height: 'calc(100vh - 200px)' }}>
            <KruskalsAlgo />
          </div>
        </Grid>
      </Grid>
    </section>
  );
}
